<template>
  <div>
    <v-container fluid>
      <v-row style="max-width: 960px" class="mx-auto mt-2">
        <v-col cols="12">
          <FlexColumn :space="4">
            <Label text="Nishika Connect" size="h4" bold />
            <Label
                text="Nishikaでは、AI・データ分析領域に特化した正社員求人・業務委託案件を掲載しています。積極的に採用担当者にアプローチして、素晴らしい企業と出会ってください！"
            />
            <JobSearchForm :conditions="conditions" @search="onSearch" />
          </FlexColumn>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid>
      <v-row class="mt-2">
        <v-col lg="12" offset-lg="0" xl="8" offset-xl="2">
          <v-row id="jobs">
            <v-col cols="12" class="py-0">
              <template v-if="initialized">
                <JobOffersList v-if="jobs.results.length > 0" :jobs="jobs.results" isTopPage />
                <FlexColumn v-else align="center">
                  <Label text="お探しの条件で求人が見つかりませんでした。" size="h5" bold />
                  <Label text="検索条件を変えてお探しください。" />
                </FlexColumn>
              </template>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import JobOffersList from "../organisms/JobOffersList";
import ComponentMixin from "../ComponentMixin";
import { mapGetters } from "vuex";
import ApiMixin from "../../ApiMixin";
import Label from "../atoms/Label";
import JobSearchForm from "../organisms/JobSearchForm";
import FlexColumn from "../atoms/FlexColumn";

export default {
  mixins: [ComponentMixin, ApiMixin],
  type: "page",
  name: "JobSearchPage",
  components: {
    FlexColumn,
    JobSearchForm,
    Label,
    JobOffersList,
  },
  data () {
    return {
      page: 1,
      loading: false,
      initialized: false
    }
  },
  computed: {
    ...mapGetters("jobs", ["searchJobsResult"]),
    ...mapGetters("user", ["user"]),
    loggedIn () {
      return this.$auth.isAuthenticated
    },
    jobs() {
      return this.searchJobsResult
    },
    jobsPage() {
      return this.page
    },
    conditions() {
      const prefectures = this.$route.query.prefectures || []
      return {
        jobType: this.$route.query.jobType,
        occupation: this.$route.query.occupation ? Number(this.$route.query.occupation) : undefined,
        salary: this.$route.query.salary ? Number(this.$route.query.salary) : undefined,
        prefectures: typeof prefectures === 'string' ? [Number(prefectures)] : prefectures.map(prefecture => Number(prefecture)),
        keyword: this.$route.query.keyword
      }
    }
  },
  methods: {
    onSearch(conditions) {
      this.conditions = conditions
      this.setJobsPage(1)
      this.loadJobs()
    },
    async loadJobs () {
      if (this.page === 1 || this.jobs.results.length === 0 || this.jobs.next) {
        await this.searchJobs(
            this.page,
            this.conditions.jobType,
            this.conditions.occupation,
            this.conditions.salary,
            this.conditions.prefectures,
            this.conditions.keyword
        )
        this.initialized = true
      }
    },
    async onScroll(){
      if (this.loading) return

      const windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      const targetBottom = document.querySelector('#jobs').getBoundingClientRect().bottom
      if ( windowHeight >= targetBottom && this.jobsPage < (Math.floor((this.jobs.count - 1) / 10)) + 1) {
        this.loading = true
        this.setJobsPage(this.jobsPage + 1)
        await this.loadJobs();
        this.loading = false
      }
    },
    setJobsPage(page) {
      this.page = page
    }
  },
  watch: {
    "$auth.loading": {
      handler: function(loading) {
        if (!loading) {
          this.loadJobs(1)
        }
      },
      immediate: true
    },
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll,true)
  },
  destroyed () {
    window.removeEventListener('scroll',this.onScroll,true)
  },
};
</script>

<style scoped lang="sass">
.sub-title-list h3
    font-size: 18px
.v-enter-active
  transition: opacity 2s
.v-enter
  opacity: 0
</style>
